import './RoundTable.scss';
import { ReactElement } from 'react';

type RoundTableCell = string | number | ReactElement;

interface Column {
    label: string;
    width?: string;
}
type Columns = Record<string, Column>;

interface RoundTableProps<C extends Columns> {
    columns: C;
    rows: (Record<keyof C, RoundTableCell> & { id: string | number })[];
}

export function RoundTable<C extends Columns>({ columns, rows }: RoundTableProps<C>) {
    const columnsArray = Object.entries<Column>(columns);

    return (
        <div
            className="RoundTable"
            style={{
                '--columns': columnsArray.length,
                '--rows': rows.length + 1,
                '--grid-template-columns': columnsArray
                    .map(([columnId, { width = 'minmax(auto, 1fr)' }]) => `[${columnId}] ${width}`)
                    .join(' '),
            }}
        >
            <div className="RoundTable__headers" style={{ '--grid-row-index': 1 }}>
                {columnsArray.map(([columnId, { label }]) => (
                    <div
                        className="RoundTable__cell"
                        key={columnId}
                        style={{ '--grid-column': columnId }}
                    >
                        {label}
                    </div>
                ))}
            </div>
            {rows.map(({ id, ...row }, rowIndex) => (
                <div
                    key={id}
                    className="RoundTable__row"
                    style={{ '--grid-row-index': rowIndex + 2 }}
                >
                    {Object.entries<RoundTableCell>(row).map(([columnId, cell]) => (
                        <div
                            className="RoundTable__cell"
                            key={columnId}
                            style={{ '--grid-column': columnId }}
                            title={
                                // TODO: replace this with an actual toolip at some point
                                typeof cell === 'string' || typeof cell == 'number'
                                    ? String(cell)
                                    : undefined
                            }
                        >
                            {cell}
                        </div>
                    ))}
                </div>
            ))}
        </div>
    );
}
